// import axios from 'axios'
import { post, put, get, remove } from '@/api/api'

export const actions = {
  fetchConfiseries({ commit }) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/confiserie`)
      .then(({ data }) => {
        commit('addConfiseries', data)
      })
  },
  async fetchConfiseriesPage({ commit }, params = {}) {
    const { page = 0, size = 10, sort = '', nom = '', salle = '', after = '', before = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort,
      ...(salle && { salle }),
      ...(nom && { nom }),
      ...(after && { after }),
      ...(before && { before }),
    }).toString();

    let { data } = await get(`/canal/confiserie/page?${queryParams}`);
    commit("addConfiseriesPage", data)
    return data;
  },
  createConfiserie({ commit }, confiserie) {
    return post('/canal/confiserie', confiserie)
      .then(({ data }) => {
        commit('addConfiserie', data)
      })
  },
  updateConfiserie({ commit }, confiserie) {
    return put(`/canal/confiserie/${confiserie.id}`, confiserie)
      .then(({ data }) => {
        commit('replaceConfiserie', data)
      })
  },
  createOrUpdateConfiserie({ dispatch }, confiserie) {
    if (confiserie.id !== undefined) {
      return dispatch('updateConfiserie', confiserie)
    } else {
      return dispatch('createConfiserie', confiserie)
    }
  },
  selectConfiserie({ commit }, confiserie) {
    commit('setConfiserie', confiserie)
  },
  deleteConfiserie({ commit }, confiserie) {
    return remove(`/canal/confiserie/${confiserie.id}`)
      .then(({ data }) => {})
  },
}
